export const getPcrStatusStyle = (status) => {
  switch (status) {
    case "Healthy":
      return "bg-green-500/20 text-green-600";
    case "Mild":
      return "bg-yellow-500/20 text-yellow-600";
    case "Moderate":
      return "bg-orange-500/20 text-orange-600";
    default:
      return "bg-red-500/20 text-red-600";
  }
};

export const getAcrStatusStyle = (status) => {
  switch (status) {
    case "Healthy":
      return "bg-green-500/20 text-green-600";
    case "Microalbuminuria":
      return "bg-yellow-500/20 text-yellow-600";
    default:
      return "bg-red-500/20 text-red-600";
  }
};
